import type { CauseOfDeath } from "shared/types";
import type { CauseOfDeathFilterFormState } from "../causeOfDeath.types";

export enum CauseOfDeathStatusFilter {
  All = 0,
  Active = 1,
  Inactive = 2,
}

export enum CauseOfDeathListTableColumn {
  Name = "name",
  Status = "status",
  Actions = "actions",
}

function isFilteredByName(name: string, searchText: string): boolean {
  if (searchText.trim() === "") {
    return true;
  }

  return name.toUpperCase().includes(searchText.trim().toUpperCase());
}

function isFilteredByStatus(
  deletionUser: string | null,
  deletedAt: string | null,
  filter: CauseOfDeathStatusFilter
): boolean {
  if (filter === CauseOfDeathStatusFilter.All) {
    return true;
  }

  if (filter === CauseOfDeathStatusFilter.Active) {
    return deletionUser == null && deletedAt == null;
  }

  return deletionUser != null || deletedAt != null;
}

export function filterCauseOfDeathPredicate(
  item: CauseOfDeath,
  filter: CauseOfDeathFilterFormState
): boolean {
  const matchesSearchText = isFilteredByName(item.name, filter.searchText);

  const matchesStatus = isFilteredByStatus(
    item.deletionUser,
    item.deletedAt,
    filter.status
  );

  return matchesSearchText && matchesStatus;
}
